var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigningDocumentPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 296,
    viewBox: "0 0 206 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.047 247.637L160.365 270.731L152.828 256.791L152.954 256.581L169.75 247.826H170.065C170.695 247.637 172.794 247.532 175.628 247.28C181.352 246.93 187.002 245.807 192.424 243.942C195.657 242.661 199.31 242.494 201.599 245.097C202.243 245.833 202.735 246.689 203.047 247.616V247.637Z",
    fill: "#111747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.406 274.947C126.057 275.094 127.946 275.997 130.571 277.047C135.772 279.475 141.282 281.177 146.946 282.106C150.39 282.505 153.707 284.101 154.483 287.481C154.665 288.438 154.665 289.421 154.483 290.378C154.491 290.448 154.491 290.518 154.483 290.588H105.965V274.695H124.86H125.238L125.406 274.947Z",
    fill: "#111747",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.852 219.025L123.705 215.078C123.768 216.338 123.81 217.681 123.852 219.025Z",
    fill: "#111747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7129 125.741C68.426 125.223 69.0225 124.561 69.4637 123.798C69.9049 123.035 70.181 122.187 70.2742 121.311C70.2958 120.98 70.2466 120.648 70.1297 120.338C70.0129 120.028 69.8311 119.746 69.5966 119.511C69.3621 119.277 69.0802 119.095 68.7699 118.978C68.4595 118.861 68.1278 118.812 67.7968 118.834C67.696 119.082 67.5618 119.315 67.3979 119.526L67.5869 115.726L68.0068 108.042C68.0424 107.823 68.0334 107.598 67.9804 107.382C67.9273 107.166 67.8314 106.963 67.6982 106.784C67.565 106.606 67.3972 106.456 67.205 106.344C67.0127 106.232 66.7999 106.16 66.5791 106.132H66.0753L67.3769 97.2091H77.0765L77.3074 94.4378H64.9836L63.241 106.174H57.3625C57.2873 105.151 56.9201 104.172 56.3044 103.352C55.6887 102.532 54.8504 101.906 53.8893 101.548C52.9282 101.191 51.8846 101.117 50.8827 101.335C49.8808 101.554 48.9627 102.055 48.2377 102.781C47.5126 103.506 47.011 104.424 46.7925 105.426C46.5741 106.427 46.6479 107.471 47.0054 108.432C47.3628 109.393 47.9887 110.232 48.8087 110.847C49.6287 111.463 50.6083 111.83 51.631 111.905L51.7989 115.139L51.9669 118.351H51.6519C50.2239 118.493 48.8913 119.133 47.8862 120.157C46.881 121.181 46.2671 122.526 46.1514 123.956L46.3613 134.58L45.8154 134.769C37.0685 137.814 28.0684 140.076 18.9213 141.529C11.6991 142.516 6.53444 142.138 4.22503 140.185C-5.24356 132.312 11.3632 84.4863 19.1942 76.7813C23.7291 72.2884 33.0087 70.3569 44.3878 68.1525C44.7771 66.6948 45.7083 65.4407 46.9911 64.6464H47.1171C54.0829 63.1373 61.2826 63.0588 68.2797 64.4154L69.0565 64.6884C69.8105 64.9413 70.4771 65.4031 70.9789 66.02C71.4806 66.637 71.7969 67.3838 71.8908 68.1735C71.8908 68.1735 88.8755 70.063 91.8987 73.5901C99.6247 82.6388 107.498 91.8554 113.418 98.1958C113.838 98.6367 124.923 88.2654 128.786 78.1249H128.912C128.912 78.1249 133.111 84.4233 140.27 83.2476C139.704 84.3814 120.724 122.235 111.718 118.939C104.097 116.125 95.8247 109.911 87.0279 102.521C83.6058 99.5185 97.3363 160.991 97.5672 162.251H88.6235L58.0763 162.418H53.4785L16.8008 162.607C16.9487 156.023 17.552 149.457 18.6064 142.956C27.8467 140.727 36.958 137.994 45.8994 134.769L46.4453 134.936C48.6488 135.915 50.9406 136.681 53.2895 137.225L53.5415 141.424C53.5232 141.836 53.663 142.239 53.9323 142.551C54.2016 142.863 54.58 143.061 54.9901 143.103H65.1515C65.5616 143.061 65.94 142.863 66.2093 142.551C66.4786 142.239 66.6184 141.836 66.6001 141.424L66.8521 136.763C69.0145 135.923 70.2742 134.664 70.2742 133.698C70.298 133.397 70.2527 133.096 70.1418 132.816C70.0309 132.535 69.8573 132.284 69.6344 132.082C69.4115 131.879 69.1451 131.73 68.8557 131.646C68.5663 131.563 68.2615 131.546 67.9648 131.598H67.8598H68.0278C68.6421 131.231 69.164 130.728 69.5535 130.127C69.9429 129.527 70.1895 128.845 70.2742 128.134C70.2995 127.82 70.2537 127.504 70.1402 127.21C70.0266 126.915 69.8483 126.651 69.6183 126.435C69.3884 126.219 69.1128 126.058 68.812 125.963C68.5112 125.868 68.1929 125.843 67.8808 125.888L67.7129 125.741Z",
    fill: "#111747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.851 42.2969C166.095 45.5301 160.762 71.6894 159.607 77.5259",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.525 77.5021C157.728 76.2735 155.692 75.4382 153.55 75.0511C151.408 74.6639 149.209 74.7337 147.096 75.2557",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.915 74.5101C120.955 70.899 110.164 77.5123 110.164 77.5123C111.067 67.015 111.907 40.2258 111.907 40.2258C129.521 32.2268 139.62 43.228 140.753 44.5717V44.6976C145.372 37.1186 160.32 36.6987 166.703 42.2833",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5591 106.133H52.8728C52.6513 106.161 52.4378 106.233 52.2446 106.345C52.0513 106.457 51.8824 106.606 51.7475 106.784C51.6126 106.962 51.5145 107.165 51.459 107.381C51.4035 107.597 51.3916 107.822 51.4241 108.043L51.6341 111.864L51.802 115.098L51.97 118.31V120.199V120.367",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3598 119.527L67.5487 115.727L67.9686 108.043C68.0042 107.824 67.9952 107.599 67.9422 107.383C67.8892 107.167 67.7932 106.964 67.66 106.785C67.5268 106.607 67.359 106.457 67.1668 106.345C66.9746 106.233 66.7617 106.161 66.541 106.133H65.7012",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.252 137.234L53.5039 141.433C53.4856 141.845 53.6255 142.248 53.8947 142.56C54.164 142.872 54.5424 143.07 54.9525 143.112H65.1139C65.524 143.07 65.9024 142.872 66.1717 142.56C66.441 142.248 66.5808 141.845 66.5626 141.433L66.8145 136.772V136.625",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0117 120.04V120.208C53.8173 124.911 64.7765 122.644 67.2958 119.537C67.4597 119.325 67.5939 119.092 67.6947 118.844",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7332 118.846C68.0692 118.815 68.4079 118.857 68.726 118.969C69.0441 119.082 69.3339 119.262 69.5755 119.498C69.817 119.734 70.0046 120.019 70.1251 120.334C70.2456 120.649 70.2963 120.987 70.2736 121.323C70.1854 122.196 69.9158 123.042 69.4819 123.804C69.0481 124.567 68.4596 125.231 67.7542 125.753C66.3697 126.818 64.7698 127.569 63.0657 127.953C61.3617 128.338 59.5944 128.346 57.8867 127.979",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8406 125.888C68.1559 125.835 68.4789 125.856 68.7851 125.947C69.0912 126.039 69.3725 126.199 69.6073 126.416C69.8422 126.632 70.0245 126.9 70.1404 127.198C70.2563 127.495 70.3027 127.816 70.276 128.134C70.1821 128.852 69.9227 129.539 69.5183 130.14C69.1139 130.741 68.5756 131.24 67.9456 131.598H67.7776C64.8577 133.322 61.4157 133.941 58.0781 133.341",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8638 131.716H67.9687C68.2563 131.667 68.5514 131.681 68.8326 131.759C69.1139 131.837 69.3743 131.977 69.5952 132.167C69.8161 132.358 69.9919 132.596 70.11 132.862C70.2281 133.129 70.2855 133.419 70.2781 133.711C70.2781 134.74 69.0605 135.999 66.856 136.923C62.4939 138.483 57.7555 138.651 53.2935 137.406C50.9445 136.862 48.6527 136.096 46.4492 135.118",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9473 115.105C56.1462 113.446 57.2589 117.204 61.4159 118.17C62.2922 118.354 63.1924 118.396 64.0822 118.296H64.3761C65.0544 118.134 65.6886 117.825 66.2331 117.389C66.7776 116.954 67.2189 116.403 67.5253 115.776",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3782 118.088L66.1208 106.142L67.4224 97.2195L77.122 97.1775L77.3529 94.4062H64.9871L63.2445 106.142L61.502 117.836",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0341 111.888H51.6352C50.6125 111.813 49.6329 111.446 48.8129 110.83C47.9929 110.214 47.367 109.376 47.0096 108.415C46.6522 107.454 46.5783 106.41 46.7967 105.408C47.0152 104.407 47.5168 103.488 48.2419 102.763C48.967 102.038 49.885 101.537 50.8869 101.318C51.8888 101.1 52.9324 101.174 53.8935 101.531C54.8546 101.888 55.6929 102.514 56.3086 103.334C56.9243 104.154 57.2916 105.134 57.3667 106.157C57.3667 106.283 57.3667 106.409 57.3667 106.535",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8483 162.516H53.1035",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0918 19.5781C49.3647 17.8146 49.6586 15.7361 50.0995 13.6366C50.6223 10.1743 52.0167 6.90162 54.1515 4.12606C59.0223 -1.16459 64.1659 0.91388 68.4698 5.51171C69.7145 6.81775 70.8519 8.22193 71.871 9.71064C74.9344 14.2626 77.2717 19.263 78.7992 24.5329C80.5418 31.818 70.0235 48.0469 67.0842 49.1596C66.74 49.2989 66.3806 49.3976 66.0135 49.4535C61.6676 50.2093 56.23 46.2623 54.4244 42.4203",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9316 64.2598C47.1416 52.0409 46.6167 40.9347 47.8344 28.7578",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8887 49.0391L66.0146 49.5429C67.0014 54.3717 67.2113 60.2712 69.0589 64.6381V64.869",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7728 21.8146C50.2629 21.0345 49.6483 20.328 48.9463 19.7151C44.1175 15.5162 40.7793 24.7958 42.6479 27.4621C43.2021 28.0869 43.9239 28.5396 44.7277 28.7666C45.5315 28.9936 46.3835 28.9854 47.1827 28.7428H47.7286C48.1323 28.6508 48.521 28.5024 48.8833 28.3019",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8305 9.84655C72.9852 9.84655 89.361 6.69735 87.0936 2.09952C85.792 -0.545805 77.1212 2.09952 68.4294 5.56364C60.1995 8.8388 51.9486 12.8278 50.0591 13.6886L49.7441 13.8355",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6035 25.8117C71.231 25.1097 73.0388 24.9407 74.7682 25.3288",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4171 25.9653C63.6444 25.4416 62.7192 25.1903 61.7877 25.2511C60.8562 25.3119 59.9715 25.6815 59.2734 26.3012",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0242 23.4375C47.101 24.2344 45.9265 24.6804 44.707 24.6972",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5419 25.8281C68.4921 28.1375 69.5419 31.8326 70.0037 34.226C70.2347 35.8846 70.5706 39.0758 67.4844 37.963",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.499 208.242C123.31 203.665 123.079 200.159 122.764 197.367C120.308 175.574 102.168 162.726 57.9746 162.516",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.408 275.504V274.79C124.967 261.185 124.673 249.869 124.421 240.401C124.421 239.939 124.421 239.456 124.421 238.994C124.232 231.1 124.064 224.529 123.917 219.028C123.917 217.642 123.917 216.341 123.791 215.081C123.791 212.583 123.645 210.315 123.561 208.258",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9261 218.902C92.9261 218.776 92.9261 218.608 92.8002 218.44L92.4223 217.075C91.8554 215.123 91.1206 212.499 90.8477 211.554H47.1788C33.7842 211.113 26.1841 203.744 21.7963 193.918C17.5973 184.45 16.7156 172.693 16.9045 162.72C17.0415 156.135 17.6449 149.569 18.71 143.069C18.857 142.208 18.962 141.684 18.983 141.516",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.008 274.803H106.113C103.888 261.807 101.305 250.281 98.8489 240.435C96.7495 231.743 94.65 224.353 92.9074 218.474L92.5295 217.109",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M165.571 236.94L155.913 211.578C152.281 202.089 149.216 194.069 148.628 192.683C139.223 169.295 138.32 162.451 91.2918 162.43H88.5205L57.9732 162.598H53.4804L16.8027 162.787",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M123.477 208.227C124.862 211.103 127.885 216.33 131.601 222.482C134.982 228.067 138.908 234.407 142.666 240.369C146.424 246.332 150.392 252.378 153.163 256.556L169.749 247.718L166.852 240.39C166.453 239.341 165.991 238.144 165.529 236.905",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9746 39.5312C58.1867 40.136 58.5344 40.6841 58.991 41.1337C59.4477 41.5833 60.0012 41.9224 60.6091 42.1251C61.2171 42.3277 61.8633 42.3885 62.4984 42.3028C63.1335 42.2172 63.7405 41.9872 64.273 41.6307",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M141.09 77.758L141.531 77.1071C144.512 72.2994 141.909 67.5756 142.098 66.1899C142.58 62.8938 145.856 63.9225 146.695 68.5833C147.125 70.7749 147.217 73.0192 146.968 75.2386C146.914 77.1209 146.24 78.9327 145.053 80.3938C143.865 81.8549 142.229 82.8839 140.397 83.3216C139.83 84.4553 120.851 122.309 111.844 119.012C104.223 116.199 95.9513 109.985 87.1546 102.595C83.6275 99.6344 97.6519 161.212 97.8829 162.555H91.3115",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M136.554 75.3594C136.415 75.6204 136.261 75.8728 136.092 76.1152",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.027 77.6953C141.204 77.5132 141.366 77.3166 141.51 77.1074C143.819 73.4753 142.287 63.6708 139.201 63.2089C138.907 63.1704 138.609 63.214 138.34 63.3349C134.729 64.7625 140.229 69.0455 136.576 75.3229",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136.094 76.1216C136.263 75.8721 136.417 75.6127 136.556 75.3448C137.476 73.7362 137.761 71.8411 137.353 70.0331C137.164 68.8994 136.031 65.5822 134.792 65.0784C134.493 64.9458 134.162 64.9044 133.84 64.9594C133.518 65.0145 133.219 65.1636 132.981 65.3879C132.743 65.6122 132.577 65.9018 132.503 66.2202C132.43 66.5387 132.452 66.8718 132.567 67.1778C134.33 72.0486 133.406 73.7072 132.063 74.6519C130.719 75.5967 129.564 75.7437 129.144 76.9613C129.037 77.3246 128.911 77.682 128.767 78.0321C124.904 88.1725 113.818 98.5438 113.398 98.103C107.478 91.8046 99.605 82.5459 91.8789 73.4972C88.8557 69.9701 71.871 68.0806 71.871 68.0806C71.7771 67.2909 71.4609 66.5441 70.9591 65.9272C70.4574 65.3102 69.7907 64.8484 69.0368 64.5955L68.281 64.4275C61.2785 63.0611 54.0713 63.1325 47.0974 64.6375H46.9714C45.6885 65.4318 44.7574 66.6859 44.3681 68.1436C33.0309 70.2431 23.7513 72.3425 19.1745 76.7724C11.3225 84.4774 -5.3053 132.303 4.18429 140.176C6.53569 142.129 11.7004 142.507 18.8805 141.52C28.0419 140.069 37.0561 137.807 45.8167 134.76L46.3625 134.571L46.1526 123.947C46.2683 122.517 46.8823 121.172 47.8874 120.148C48.8925 119.124 50.2252 118.485 51.6532 118.342",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.753 44.25L140.732 44.5649L139.221 63.0822",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M128.912 78.125C128.912 78.125 133.111 84.4234 140.27 83.2477",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5918 143.4C17.2426 143.4 17.9145 143.211 18.6913 143.064C27.9316 140.835 37.0429 138.102 45.9843 134.876L48.5247 134.016",
    stroke: "white",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4453 28.8984C73.668 28.8984 73.8816 28.9869 74.0391 29.1444C74.1966 29.3019 74.285 29.5155 74.285 29.7382C74.285 29.9609 74.1966 30.1746 74.0391 30.332C73.8816 30.4895 73.668 30.578 73.4453 30.578C73.2225 30.578 73.0089 30.4895 72.8514 30.332C72.6939 30.1746 72.6055 29.9609 72.6055 29.7382C72.6055 29.5155 72.6939 29.3019 72.8514 29.1444C73.0089 28.9869 73.2225 28.8984 73.4453 28.8984Z",
    fill: "#111747"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2421 28.8984C63.4082 28.8984 63.5706 28.9477 63.7087 29.04C63.8468 29.1322 63.9544 29.2634 64.018 29.4168C64.0816 29.5703 64.0982 29.7392 64.0658 29.9021C64.0334 30.065 63.9534 30.2146 63.836 30.332C63.7185 30.4495 63.5689 30.5295 63.406 30.5619C63.2431 30.5943 63.0742 30.5776 62.9208 30.5141C62.7673 30.4505 62.6362 30.3429 62.5439 30.2048C62.4516 30.0667 62.4023 29.9043 62.4023 29.7382C62.4023 29.5155 62.4908 29.3019 62.6483 29.1444C62.8058 28.9869 63.0194 28.8984 63.2421 28.8984Z",
    fill: "#111747"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M105.986 290.979V294.653H154.589V290.664H154.505H106.007H105.986V290.979Z",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M160.723 270.546L186.294 256.773",
    stroke: "white",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M160.512 270.99L162.254 274.202L204.999 251.129L203.11 247.602L203.047 247.644L160.365 270.696H160.344L160.512 270.99Z",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3858 182C46.6167 190.398 41.3051 195.626 34.3979 198.103C31.6931 199.051 28.8634 199.596 26 199.719",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M169.978 247.662C170.608 247.473 172.708 247.368 175.542 247.116C181.265 246.766 186.915 245.643 192.338 243.778C195.571 242.497 199.224 242.329 201.512 244.933C202.156 245.669 202.649 246.525 202.961 247.452V247.641L160.972 270.42L153.225 256.837L169.978 247.662Z",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2744 122.522C43.4666 123.383 25.4952 126.07 20.0156 126.721C21.4578 117.249 24.1842 108.017 28.1196 99.2812",
    stroke: "white",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigningDocumentPerson);
export default __webpack_public_path__ + "static/media/signing-document-person.6fe81c8e79ede3a6aa95ce7bde53ee6e.svg";
export { ForwardRef as ReactComponent };